import { useTranslation } from "react-i18next";
import AccessibleContent from '../../../utils/AccessibleContent';

const TopSection = ({ step, store, lang, selectedStore }) => {
  const { t } = useTranslation();

  // Détermine le contenu de la tête selon les données disponibles
  const getHeadContent = () => {
    if (store.discount && store.discount.teaser) {
      return store.discount.teaser[lang] || '';
    } else {
      return selectedStore === 'digital'
        ? (store.texteAccroche && store.texteAccroche[lang] ? store.texteAccroche[lang].replace("<p>", "<h2>").replace("</p>", "</h2>") : '')
        : (store.physical_store && store.physical_store.texts
          ? store.physical_store.texts.card_list_teaser[lang]
          : '');
    }
  };

  return (
    <div id="topSection" role="region" aria-label="Information de l'enseigne">
      <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
        {step === 1 && (
          <div className="wrapper">



            <AccessibleContent
              className="headContent accrocheColor"
              htmlContent={getHeadContent()}
            />

            {!store.exception && (
              <div className="showMoreBox">
                <a href="/details">{t("En savoir plus")}</a>
              </div>
            )}
          </div>
        )}
        {step === 2 && (
          <div className="wrapper">
            <div className="headContent">{t("Vérifiez votre achat et renseignez vos coordonnées")}</div>
          </div>
        )}
        {step === 3 && (
          <div className="wrapper">
            <div className="headContent">
              {t("Votre commande a été enregistrée avec succès ! Gardez précieusement ces informations.")}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default TopSection;